import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Socket } from 'ngx-socket-io';

@Injectable({
	providedIn: 'root'
})
export class SocketService {
	constructor(
		private socket: Socket
	) { }

	/**
	 * listen to the emitted events
	 * @param eventName: event name string
	 */
	listen(eventName: string) {
		this.socket.connect();
		return new Observable((observer) => {
			this.socket.on(eventName, (message) => {
				observer.next(message);
			});
		});
	}

	/**
 	 * Emit event to the server
 	 * @param eventName: event name string
 	 * @param data: data to be with event
 	*/
	emit(eventName: string, data: string) {
		this.socket.emit(eventName, data);
	}
}
